import { environment } from "../../environment";
import { store } from "../../redux/store";
import { PAGE_TEMPLATES } from "./templates";

const getDynamicPageBasePaths = () => {
    const dynamicPagesData = store.getState().dynamicPagesData;
    const paths = {};

    for (const key of Object.keys(PAGE_TEMPLATES)) {
        if (!["PRODUCT_OVERVIEW", "PRODUCT_DETAIL"].includes(key)) continue;

        paths[key] = dynamicPagesData[PAGE_TEMPLATES[key]];
    }

    return paths;
};

export const DYNAMIC_PAGE_PATHS = {
    ...getDynamicPageBasePaths(),
};

export const DYNAMIC_PAGE_QUERY_KEYS = {
    PRODUCT_OVERVIEW: "category",
    PRODUCT_DETAIL: "product",
};

export const STATIC_PAGE_PATHS = {
    HOME: environment.APP_BASE,
    CART: "/cart",
    CHECKOUT: "/checkout",
};
